import { inject, Injectable } from '@angular/core';
import { WidgetBaseFilterModel } from '@clean-code/models';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';
import { IMarketHknDistribution } from '../market-hkn-distribution-content/market-hkn-distribution-content.models';

@Injectable({
  providedIn: 'root',
})
export class MarketHknDistributionService {
  private graphqlService = inject(GraphqlService);

  public dashboardClosedHKNByType$(
    value: WidgetBaseFilterModel,
  ): Observable<IMarketHknDistribution[]> {
    const query = `
    query($input: WidgetBaseFilterInput!) {
            dashboardClosedHKNByType(input: $input)
            {
              key
              value
            }
          }`;

    return this.graphqlService.query<IMarketHknDistribution[]>(query, {
      input: value,
    });
  }
}
